<svelte:options customElement={{ tag: "bt-action-button", shadow: "none", }} />

<script lang="ts">
  export let buttonClasses = '';
  export let buttonStyles = '';
  export let buttonEl = null;
  export let design = '';
  export let isDisabled: boolean | string = false;
  export let buttonType = 'button'
  export let link = '';
  export let text = '';

  $: {
    if (isDisabled === 'false') {
      isDisabled = false;
    }
  }
</script>

{#if link}
  <a
    href={link}
    class="action-button {buttonClasses} {design}"
    style={buttonStyles}
    on:click
    bind:this={buttonEl}
    disabled={isDisabled}
  >
    {#if text}
      {text}
    {:else}
      <slot></slot>
    {/if}
  </a>
{:else}
  <button
    type={buttonType}
    class="action-button {buttonClasses} {design}"
    style={buttonStyles}
    on:click
    bind:this={buttonEl}
    disabled={isDisabled}
  >
    <slot></slot>
  </button>
{/if}

<style>
  :global(bt-action-button) {
    display: block;
    width: fit-content;
  }
  :global(.action-button svg) {
    flex-shrink: 0;
    margin-left: .5rem;
  }
  :global(.action-button.text-button svg) {
    flex-shrink: 0;
    margin-left: 0;
  }
  button, a {
    display: flex;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
    text-align: center;
    gap: .5rem;
    padding: .5rem 1rem;
    min-height: 42px;
    font-weight: 500;
    cursor: pointer;
    font-family: "ibm-plex-sans";
    font-size: theme('fontSize.sm');
    line-height: 20px;
    border-width: 1px;
    border-radius: 8px;
    transition: all 100ms ease-in-out;
  }
  button:has(:nth-child(2)), a:has(:nth-child(2)) {
    justify-content: space-between;
  }
  button.primary, a.primary {
    background: theme("colors.neutral.900");
    color: theme("colors.white");
    border-color: theme("colors.neutral.900");
    &:hover {
      background: theme("colors.white");
      color: theme("colors.neutral.900");
    }
    &:disabled {
      background: theme("colors.neutral.500");
      color: theme("colors.neutral.300");
      border-color: theme("colors.neutral.500");
      &:hover {
        cursor: not-allowed;
      }
    }
    &.yellow {
      background: theme("colors.yellow");
      color: theme("colors.black");
      border-color: theme('colors.yellow');
    }
    &.yellow:hover {
      background: theme("colors.white");
    }
  }
  button.secondary, a.secondary {
    background: theme("colors.white");
    color: theme("colors.neutral.900");
    border: 1px solid theme('colors.neutral.300');
    &:hover {
      background: theme("colors.neutral.900");
      color: theme("colors.white");
      border-color: theme("colors.neutral.900");
    }
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
      background: theme("colors.neutral.200");
      color: theme("colors.neutral.400");
      border: 1px solid transparent;

      &:hover {
        cursor: not-allowed;
        background: theme("colors.neutral.200");
        color: theme("colors.neutral.400");
      }
    }
  }
  button.tertiary, a.tertiary {
    background: transparent;
    color: black;
    border: none;
    &:hover {
      background: transparent;
      color: theme("colors.neutral.500");
    }
  }
  button.primary-small {
    background: theme("colors.neutral.900");
    color: theme("colors.white");
    border-color: theme("colors.neutral.900");
    font-weight: normal;
    font-size: theme('fontSize.sm');
    flex-grow: 0;
    border-radius: 6px;
    &:hover {
      background: theme("colors.white");
      color: theme("colors.neutral.900");
    }
    &:disabled {
      background: theme("colors.neutral.500");
      color: theme("colors.neutral.300");
      border-color: theme("colors.neutral.500");
      &:hover {
        cursor: not-allowed;
      }
    }
  }
  button.text-button {
    background: white;
    color: theme("colors.neutral.800");
    border-color: transparent;
    font-weight: normal;
    font-size: theme('fontSize.sm');
    flex-grow: 0;
    border-radius: 6px;
    font-weight: 500;
    padding: 10px 0;
    &:hover {
      background: theme("colors.white");
      color: theme("colors.neutral.900");
    }
    &:disabled {
      background: theme("colors.neutral.500");
      color: theme("colors.neutral.300");
      border-color: theme("colors.neutral.500");
      &:hover {
        cursor: not-allowed;
      }
    }
  }

  button.menu-button {
    background: white;
    color: theme("colors.neutral.800");
    border-color: transparent;
    font-weight: normal;
    font-size: theme('fontSize.sm');
    flex-grow: 0;
    border-radius: 6px;
    padding: 10px 0;
    text-align: left;
    width: 100%;
    &:hover {
      background: theme("colors.white");
      color: theme("colors.neutral.900");
    }
    &:disabled {
      background: theme("colors.neutral.500");
      color: theme("colors.neutral.300");
      border-color: theme("colors.neutral.500");
      &:hover {
        cursor: not-allowed;
      }
    }
  }
  :global(.action-button.menu-button svg) {
    flex-shrink: 0;
    margin-left: 0;
    align-self: center;
  }
  :global(.modal__close-x--share svg) {
    margin-left: 1.3rem;
  }
  :global(.modal__close-x--assign svg) {
    margin-left: 0.8rem;
  }
</style>
